import CommentLikeButton from "./comment-like-button";


export default CommentLikeButton;